export default "__VITE_ASSET__Caj00vFy__"